import userCredentialsReducer from './userCredentialsReducer';

export default userCredentialsReducer;
